module.exports = __webpack_public_path__ + "static/media/home.4b31330b.jpg";